
import React from 'react';

interface ProductPriceDisplayProps {
  price: number;
  discountPrice: number | null;
  currency: string;
}

const ProductPriceDisplay = ({ price, discountPrice, currency }: ProductPriceDisplayProps) => {
  const discountPercentage = discountPrice ? Math.round((1 - discountPrice / price) * 100) : 0;
  
  return (
    <div className="flex items-baseline mb-4">
      {discountPrice ? (
        <>
          <span className="text-3xl font-bold text-primary mr-2">
            {discountPrice.toFixed(2)} {currency}
          </span>
          <span className="text-xl text-gray-500 line-through">
            {price.toFixed(2)} {currency}
          </span>
          <span className="ml-2 px-2 py-1 text-xs font-semibold bg-red-100 text-red-800 rounded-full">
            {discountPercentage}% OFF
          </span>
        </>
      ) : (
        <span className="text-3xl font-bold text-primary">
          {price.toFixed(2)} {currency}
        </span>
      )}
    </div>
  );
};

export default ProductPriceDisplay;
